import * as React from 'react';
import Grid from '@able/react/dist/Grid';
import Column from '@able/react/dist/Column';
import Spacing from '@able/react/dist/Spacing';
import Surface from '@able/react/dist/Surface';
import {CustomerDetailsSection} from './components/customer-details-section';
import {OrderContactsSection} from './components/order-contacts-section';
import {OrderDetailsSection} from './components/order-details-section';
import {OrderTimingSection} from './components/order-timing-section';
import {IOrderSummarySectionsProps} from '../../../../../config/order-tracker-new-common/types';
import {
    showOrderContactsSection,
    showOrderDetailsSection
} from '../../../../../config/order-tracker-new-common/order-products-utils';

const OrderSummarySections = ({surfaceCornerRadius, className, orderSummary}: IOrderSummarySectionsProps) => {
    return (
        <Surface
            className={className}
            background="materialBasePrimary"
            cornerRadius={surfaceCornerRadius}
            interactive={false}
            variant="SurfaceFlat"
        >
            <Spacing
                top="spacing4x"
                bottom="spacing4x"
                left="spacing3x"
                right="spacing3x"
            >
                <Grid>
                    <Column cols={6} vxs={12}>
                        <Spacing bottom="spacing2x">
                            <OrderTimingSection orderSummary={orderSummary}/>
                        </Spacing>
                        {showOrderDetailsSection(orderSummary) &&
                            <Spacing bottomVXS="spacing2x">
                                <OrderDetailsSection orderSummary={orderSummary}/>
                            </Spacing>
                        }
                        {!showOrderDetailsSection(orderSummary) && showOrderContactsSection(orderSummary) &&
                            <Spacing bottomVXS="spacing2x">
                              <OrderContactsSection orderSummary={orderSummary}/>
                            </Spacing>
                        }
                    </Column>
                    <Column cols={6} vxs={12}>
                        {showOrderDetailsSection(orderSummary) && showOrderContactsSection(orderSummary) &&
                            <Spacing bottomVXS="spacing2x">
                                <OrderContactsSection orderSummary={orderSummary}/>
                            </Spacing>
                        }
                        <CustomerDetailsSection orderSummary={orderSummary}/>
                    </Column>
                </Grid>
            </Spacing>
        </Surface>
    );
};

export default OrderSummarySections;
